const EXTERNAL_PROTOCOLS = new Set(["http:", "https:"]);

const sanitizeAttributeUrl = (value) => {
  if (typeof value !== "string") return false;
  return !/^javascript:/i.test(value.trim());
};

export const sanitizeHtml = (html) => {
  if (html == null) return "";

  const value = String(html);

  if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
    return value;
  }

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(`<div>${value}</div>`, "text/html");
  const root = doc.body.firstElementChild || doc.body;

  root
    .querySelectorAll("script,style,iframe,object,embed,link,meta,base,form,input,button,textarea,select,option")
    .forEach((node) => node.remove());

  root.querySelectorAll("*").forEach((node) => {
    Array.from(node.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const attrValue = attr.value || "";

      if (name.startsWith("on")) {
        node.removeAttribute(attr.name);
        return;
      }

      if ((name === "href" || name === "src" || name === "xlink:href") && !sanitizeAttributeUrl(attrValue)) {
        node.removeAttribute(attr.name);
        return;
      }

      if (name === "style" && /(expression\s*\(|javascript:)/i.test(attrValue)) {
        node.removeAttribute(attr.name);
      }
    });
  });

  return root.innerHTML;
};

export const getSafeExternalUrl = (value) => {
  if (typeof value !== "string") return null;

  const raw = value.trim();
  if (!raw) return null;

  const candidate = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(raw) ? raw : `https://${raw}`;

  try {
    const parsed = new URL(candidate);
    if (!EXTERNAL_PROTOCOLS.has(parsed.protocol)) return null;
    return parsed.toString();
  } catch (error) {
    return null;
  }
};

export const getSafeTelHref = (value) => {
  if (typeof value !== "string" && typeof value !== "number") return null;
  const normalized = String(value).trim().replace(/[^+\d]/g, "");
  if (!normalized) return null;
  return `tel:${normalized}`;
};

export const getCookieOptions = ({ expiresHours } = {}) => {
  const options = {
    sameSite: "Lax",
  };

  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    options.secure = true;
  }

  if (typeof expiresHours === "number") {
    options.expires = expiresHours / 24;
  }

  return options;
};
